module.exports = __webpack_public_path__ + "static/media/saving-plans.8ae6bb5.8ae6bb59.svg";